type Props = { fill: number; size?: number; className?: string }

// The Social Brew logo cup (no steam) that fills with coffee to match the score —
// the brand mug-fill mechanic rendered with the real logo shape instead of a drawn cup.
// It stacks two copies of the logo image: a faint "empty" cup, and a full-opacity copy
// cropped from the bottom up to the coffee level. In the logo image the cup bowl spans
// roughly 19.7%–60.9% of the square measured from the bottom, so the score is mapped
// into that range (0% = empty bowl, 100% = full to the rim).
export default function BrewFillCup({ fill, size = 48, className }: Props) {
  const clamped = Math.max(0, Math.min(100, fill))
  const coffeePct = 19.7 + (clamped / 100) * 41.2
  // A perfect 100% pour earns the Social Brew mug its steam — rising wisps above
  // the rim, shown only when the cup is full to the top.
  const full = clamped >= 100
  const imgStyle: React.CSSProperties = {
    position: 'absolute', left: 0, bottom: 0, width: size, height: size, objectFit: 'contain',
  }
  return (
    <div className={className} style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      <img src="/logo-cup-nosteam.png" alt="" aria-hidden="true" style={{ ...imgStyle, opacity: 0.16 }} />
      <div style={{ position: 'absolute', left: 0, bottom: 0, width: size, height: `${coffeePct}%`, overflow: 'hidden' }}>
        <img src="/logo-cup-nosteam.png" alt="" aria-hidden="true" style={imgStyle} />
      </div>
      {full && (
        <svg aria-hidden="true" viewBox="0 0 48 48"
          style={{ position: 'absolute', left: 0, top: 0, width: size, height: size, overflow: 'visible', pointerEvents: 'none' }}>
          {[
            { d: 'M18,18 Q15,11 18,4', delay: '0s', dur: '2s' },
            { d: 'M24,19 Q27,11 24,3', delay: '0.5s', dur: '2.3s' },
            { d: 'M30,18 Q27,11 30,4', delay: '0.25s', dur: '2.1s' },
          ].map((w, i) => (
            <path key={i} d={w.d} fill="none" stroke="rgba(150,120,90,0.55)" strokeWidth="1.6" strokeLinecap="round"
              style={{ animation: `sbSteamRise ${w.dur} ease-in-out infinite`, animationDelay: w.delay }} />
          ))}
        </svg>
      )}
    </div>
  )
}
